import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { ChatComponent } from './chat';
import { TranslateModule } from '@ngx-translate/core';
import { ConvertDatePipe } from '../../pipes/convert-date/convert-date';
import { KintipsAvatarComponentModule } from '../kintips-avatar/kintips-avatar.module';
import { PipeModules } from '../../pipes/pipes.modules';

@NgModule({
  declarations: [
    ChatComponent,
    ConvertDatePipe
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild(),
    KintipsAvatarComponentModule,
    PipeModules
  ],
  exports: [
    ChatComponent
  ]
})
export class ChatComponentModule {}



// WEBPACK FOOTER //
// ./src/components/chat/chat.module.ts